
export const INIT_DATA_BRAND = [
  {
    brand: '',
    comp1: '',
    comp2: '',
    comp3: '',
    comp4: '',
    comp5: '',
    comp6: '',
    comp7: '',
    comp8: '',
    comp9: '',
  }
];

export const INIT_DATA_COMP = [
  {
    brand: { prev: 0, next: 0, name: '', isNotExact: false },
    comp1: { prev: 0, next: 0, name: '', isNotExact: false },
    comp2: { prev: 0, next: 0, name: '', isNotExact: false },
    comp3: { prev: 0, next: 0, name: '', isNotExact: false },
    comp4: { prev: 0, next: 0, name: '', isNotExact: false },
    comp5: { prev: 0, next: 0, name: '', isNotExact: false },
    comp6: { prev: 0, next: 0, name: '', isNotExact: false },
    comp7: { prev: 0, next: 0, name: '', isNotExact: false },
    comp8: { prev: 0, next: 0, name: '', isNotExact: false },
    comp9: { prev: 0, next: 0, name: '', isNotExact: false },
  }
];

export const INIT_DATA_SOURCE = [
  {
    key: '4',
    sow: 'Sample',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '0',
    sow: 'Cleaning',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '1',
    sow: 'Sentiment',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '2',
    sow: 'Tag',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '3',
    sow: 'Attribute',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '5',
    sow: 'BSI',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '6',
    sow: 'Data Management',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '7',
    sow: 'Charting & Analysis',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '8',
    sow: 'Project Management',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '9',
    sow: 'Client Service',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '10',
    sow: 'General Management',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
  {
    key: '11',
    sow: 'Unit Cost',
    freq: 'Monthly',
    brand1: 0,
    brand2: 0,
    brand3: 0,
    brand4: 0,
    brand5: 0,
    brand6: 0,
    brand7: 0,
    brand8: 0,
    brand9: 0,
    brand10: 0,
    time: 0,
    unit_price: 0,
  },
];
